import RdBudgetFormService from '../../../services/rdBudgetFormService';

export const approveBudget = (
  organizationId: string,
  propertyId: string,
  rentForecastId: string,
): Promise<any> => {
  const rdBudgetFormService = new RdBudgetFormService();

  return rdBudgetFormService.approveBudget(
    organizationId,
    propertyId,
    rentForecastId,
  );
};
